import type { FaireProductEntity } from "../../entity_types/product";

export const p_x8n3carygk: FaireProductEntity = {
  token: "p_x8n3carygk",
  type: "product",
  name: "Shiny Crystal And Freshwater Pearl Bracelets",
  brandToken: "b_y2j497tv82",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/107c171b34a3a9fda8640ee4d19c433087a7958971cb738f224766b8aa4e3371.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e18ed890ec77114b1072b3d449fb20cacd1e9097f3a0dbfe645ec7f6fb34a0d3.jpeg"
  ],
  priceDollars: 6.24,
  description: "Natural freshwater pearls\nShiny crystal\nHandmade\nBracelet length 16.5CM + 4.5CM",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:50.886Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
